import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from "react";
import Login from "./components/LoginScreen";
import Sidebar from './components/Sidebar';
import AttendanceHistory from './components/AttendanceHistory';
import RequestForLeave from './components/RequestForLeave';
import HomeScreen from './components/HomeScreen';
import ServerError from './components/ServerError';
// import SplashScreen from './components/SplashScreen';
import UpdatePassword from './components/UpdatePassword';
import LeaveManagement from './components/LeaveManagement';
import EmployeeDetailsCard from './components/EmployeeDetails';
import SignIn from './components/SignIn';

const Profile = () => <div>Profile Page</div>;

// 🔐 Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const employeeDetails = JSON.parse(localStorage.getItem("employeeDetails"));
  const isLoggedIn = !!employeeDetails?.token;

  if (!isLoggedIn) {
    alert("Unauthorized access. Please login first.");
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children ? children : <Outlet />;
};

// 🚀 PublicRoute wrapper to redirect if already logged in
const PublicRoute = ({ children }) => {
  const employeeDetails = JSON.parse(localStorage.getItem("employeeDetails"));
  const isLoggedIn = !!employeeDetails?.token;

  if (isLoggedIn) {
    return <Navigate to="/sidebar/home" replace />;
  }

  return children;
};

const App = () => {
  const [showSplash, setShowSplash] = useState(false);
  console.log("splash worked",showSplash);
  

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const hasSeenSplash = sessionStorage.getItem("hasSeenSplash");

    if (isMobile && !hasSeenSplash) {
      setShowSplash(true);
      sessionStorage.setItem("hasSeenSplash", "true");
      setTimeout(() => setShowSplash(false), 3000);
    }
  }, []);

  return (
    <>
      {/* {showSplash ? (
        <SplashScreen />
      ) : ( */}
        <Routes>
          {/* Public Login Route */}
          <Route
            path="/"
            element={
              <PublicRoute>
                {/* <Login /> */}
                <SignIn/>
              </PublicRoute>
            }
          />
          <Route path="/servererror" element={<ServerError />} />
          {/* Protected Routes */}
          <Route path="/sidebar" element={<ProtectedRoute><Sidebar /></ProtectedRoute>}>
            <Route index element={<Navigate to="home" replace />} />
            <Route path="home" element={<HomeScreen/>} />
            <Route path="history" element={<AttendanceHistory />} />
            <Route path="profile" element={<Profile />} />
            <Route path="leaveRequestForm" element={<RequestForLeave />} />
            <Route path="update-password" element={<UpdatePassword />} />
            <Route path="leaveManagement" element={<LeaveManagement />} />
            <Route path='employeeDetails' element={<EmployeeDetailsCard/>}/>
          </Route>
            <Route path='login' element={<Login/>}/>
          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      {/* )} */}
    </>
  );
};


export default App;
